{
  "name": "@langfuse/core",
  "version": "4.6.0",
  "description": "Core functions and utilities for Langfuse packages",
  "type": "module",
  "sideEffects": false,
  "main": "./dist/index.cjs",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs"
    }
  },
  "scripts": {
    "build": "tsup",
    "test": "vitest run",
    "test:watch": "vitest",
    "format": "prettier --write \"src/**/*.ts\"",
    "format:check": "prettier --check \"src/**/*.ts\"",
    "clean": "rm -rf dist"
  },
  "author": "Langfuse",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/langfuse/langfuse-js.git",
    "directory": "packages/core"
  },
  "files": [
    "dist"
  ],
  "peerDependencies": {
    "@opentelemetry/api": "^1.9.0"
  },
  "devDependencies": {
    "@types/node": "^24.1.0"
  }
}
